<script setup lang="ts">
import { type Mutable } from 'type-fest';
import ImageSelector from './ImageSelector.vue';
import LocalCaptcha from '@components/util/LocalCaptcha.vue';
import {
    HotelCaptchaApiApiHotelCommentCaptchaGet,
    type HotelCommentsApiApiHotelHotelIdAddCommentPostRequest,
} from '@clients/HotelApi';

const { hotelId, hotelName } = defineProps<{
    hotelName: string;
    hotelId: number;
}>();
const emit = defineEmits<{
    close: [];
}>();
const request = ref<
    Mutable<HotelCommentsApiApiHotelHotelIdAddCommentPostRequest>
>({
    body: '',
    photos: [],
    commentRatings: [],
    hotelId,
});
const rating = ref(0);
const hotelModule = useHotelModule();
onMounted(() => {
    hotelModule.loadRatingFactors();
});
const submitDisabled = computed(
    () =>
        request.value.body?.length === 0 ||
        rating.value === 0 ||
        !request.value.dNTCaptchaInputText
);
const submitLoading = ref(false);
const fetcher = async () => {
    const { data } = await HotelCaptchaApiApiHotelCommentCaptchaGet({
        withCredentials: true,
    });
    return {
        token: data.dntCaptchaTokenValue ?? '',
        text: data.dntCaptchaTextValue ?? '',
        image: data.dntCaptchaImgUrl ?? '',
    };
};
async function submit() {
    try {
        submitLoading.value = true;
        await hotelModule.addComment(request.value, rating.value);
        swal({
            text: 'نظر شما با موفقیت ثبت شد و پس از تأیید در سایت نمایش داده خواهد شد.',
            icon: 'success',
        });
        emit('close');
    } catch (e) {
        const error = e as any;
        const dntCaptchaInputText = error?.response?.data?.DNTCaptchaInputText;
        if (dntCaptchaInputText?.length) {
            handleException({ response: { data: dntCaptchaInputText[0] } });
        } else {
            handleException(e);
        }
    } finally {
        submitLoading.value = false;
    }
}
const label = computed(() => `به ${hotelName} چه امتیازی می‌دهید؟`);
</script>
<template>
    <mr-modal title="ثبت نظر جدید" mobile-page @close="emit('close')">
        <div class="content">
            <mr-rating
                v-model="rating"
                :label
                description="انتخاب امتیاز ضروری است."
            />
            <mr-divider class="divider" />
            <mr-input
                v-model="request.body"
                text-area
                label="متن نظر"
                description="حداکثر ۵۰۰ کاراکتر"
                :max-length="500"
                required
                full-width
            />
            <mr-divider class="divider" />
            <div class="upload-images">
                <ImageSelector v-model="request.photos" />
            </div>
            <mr-divider class="divider" />
            <LocalCaptcha
                v-model:input="request.dNTCaptchaInputText"
                v-model:text="request.dNTCaptchaText"
                v-model:token="request.dNTCaptchaToken"
                :fetcher
            />
        </div>
        <template #footer>
            <mr-button
                :disabled="submitDisabled"
                full-width
                :loading="submitLoading"
                @click="submit"
            >
                ذخیره
            </mr-button>
        </template>
    </mr-modal>
</template>
<style scoped lang="scss">
.content {
    display: flex;
    flex-direction: column;
    gap: 12px;
}
</style>
